import React, { useRef, useEffect, useState } from 'react';
import CommonInput from '../Resusable/CommonInput';
import moment from 'moment';

const generateNewShippingDate = (
	dateOfShipping,
	minDate,
	maxDate,
	onChangeHandler,
	onErrorHandler
) => {
	let currentDate = new Date();
	let regxForDate = /^[\+]{1}[0-9]+$/;

	if (dateOfShipping === '.') {
		onChangeHandler(currentDate);
	} else if (regxForDate.test(dateOfShipping)) {
		let numberOfDaysToAdd = dateOfShipping.split('+');
		if (numberOfDaysToAdd.length >= 1) {
			let newShippingDate = new Date(currentDate);
			newShippingDate.setDate(
				newShippingDate.getDate() + parseInt(numberOfDaysToAdd[1])
			);
			if (
				moment(newShippingDate).subtract(1, 'days').isBefore(moment(maxDate))
			) {
				onChangeHandler(newShippingDate);
			} else {
				onChangeHandler('');
			}
		}
	} else {
		if (
			dateOfShipping.length &&
			moment(dateOfShipping).isSameOrAfter(
				moment(minDate).format('DD MMM YYYY')
			) &&
			moment(dateOfShipping).isSameOrBefore(
				moment(maxDate).format('DD MMM YYYY')
			)
		) {
			onChangeHandler(moment(dateOfShipping, "DD MMM YYYY").toDate());
		} else {
			if (onErrorHandler) onErrorHandler();
		}
	}
};

const AppCalendar = ({
	value,
	onChangeHandler,
	onFocusHandler,
	placeholder,
	minDate,
	maxDate,
	disabled,
	onErrorHandler,
	className,
	setMultiComponentFlightDateError,
	componentIndex,
	label,
	id = 'calendar-input',
	error
}) => {
    const wrapperRef = useRef(null);
    const calendarRef = useRef(null);
    const [calendarPosition, setCalendarPosition] = useState('');

    useEffect(() => {
        const attachRef = () => {
            const calendarWrapper = document.querySelector(`.calendar-wrapper-${id}`);
            if (calendarWrapper) {
                wrapperRef.current = calendarWrapper;
            }
        };
        
        const timeout = setTimeout(attachRef, 0);

        const calculatePosition = () => {
           
            const calendarPanel = document.querySelector('.p-datepicker:not([style*="display: none"])');
            
            if (calendarPanel && wrapperRef.current) {
                const rect = wrapperRef.current.getBoundingClientRect();
                const viewportHeight = window.innerHeight;
                const viewportWidth = window.innerWidth;
                
                const spaceBelow = viewportHeight - rect.bottom;
                const spaceAbove = rect.top;
                const spaceRight = viewportWidth - rect.right;
                const spaceLeft = rect.left;
                
                const calendarHeight = 400;
                const calendarWidth = 360; 
                const padding = 20;

                let position = '';

              
                const canFitBelow = spaceBelow >= (calendarHeight + padding);
                const canFitAbove = spaceAbove >= (calendarHeight + padding);
                if (!canFitBelow && !canFitAbove) {
                    
                    if (spaceRight >= (calendarWidth + padding)) {
                        position = 'center-right';
                    } 
                    
                    else if (spaceLeft >= (calendarWidth + padding)) {
                        position = 'center-left';
                    }
                    else {
                        position = spaceBelow > spaceAbove ? 'bottom-left' : 'top-left';
                    }
                } else {
                    const vertical = canFitBelow ? 'bottom' : 'top';
                    const horizontal = spaceRight < (calendarWidth + padding) && spaceLeft > spaceRight ? 'right' : 'left';
                    
                    position = `${vertical}-${horizontal}`;
                }

                if (position !== calendarPosition) {
                    setCalendarPosition(position);
                    calendarPanel.setAttribute('data-calendar-position', position);
                }
            } else if (!calendarPanel && calendarPosition) {
               
                setCalendarPosition('');
            }
        };

        const observer = new MutationObserver(calculatePosition);

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class']
        });

        const handleScrollResize = () => {
            if (calendarPosition) {
                calculatePosition();
            }
        };

        window.addEventListener('scroll', handleScrollResize, true);
        window.addEventListener('resize', handleScrollResize);

        return () => {
            // clearTimeout(timeout);
            observer.disconnect();
            window.removeEventListener('scroll', handleScrollResize, true);
            window.removeEventListener('resize', handleScrollResize);
        };
    }, [calendarPosition, id]);

    const handleBlur = (e) => {
		e.preventDefault();
		const inputValue = e.target.value;

		if (inputValue && inputValue.length) {
			generateNewShippingDate(
				inputValue,
				minDate,
				maxDate,
				onChangeHandler,
				onErrorHandler
			);
		} else {
			if (onErrorHandler) onErrorHandler();
		}

		if (
			setMultiComponentFlightDateError &&
			componentIndex !== undefined
		) {
			setMultiComponentFlightDateError(
				'FLIGHT_DATE',
				inputValue,
				componentIndex
			);
		}
	};

	return (
		<CommonInput
			type="calendar"
			value={value}
			onChange={(e) => {
				onChangeHandler(e.value);
				if (
					setMultiComponentFlightDateError &&
					componentIndex !== undefined
				) {
					setMultiComponentFlightDateError(
						'FLIGHT_DATE',
						e.value,
						componentIndex
					);
				}
			}}
			onFocus={onFocusHandler}
			onBlur={handleBlur}
			placeholder={placeholder}
			minDate={minDate}
			maxDate={maxDate}
			disabled={disabled}
			className={className}
			label={label}
			id={id}
			error={error}
			calendarRef={calendarRef}
            wrapperClassNameCalender={`calendar-wrapper calendar-wrapper-${id} ${calendarPosition ? `position-${calendarPosition}` : ''}`}
		/>
	);
};

export default AppCalendar;